import api from '../service/apiService'
import { apiUrl } from '../constants/apiUrl'
import { errorAction } from './error';
import { getCartHeader, getCartData } from './../util/cartUtility';
//import { loaderActive } from './loder';
import { logKafka, logOtherInfo, detailsInfo, catchJSException } from './../service/logService';
import { InHomeUtils } from '../util/inhomeUtils';
import { redirectTo } from './redirection';
import { loaderActive } from './loder';
import { Pages, PAGEACTIVITY, Moves } from './../constants/actionType';
import movesExpJson from './../containers/move/movesExpJson.json';
import sampleCartJson from './../containers/cart/sampleCartJson.json';
import sampleComparePrice from './../containers/move/sampleComparePrice.json';

let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;

const getRequest = () => {
    let request = {
        key: "UPDATECARTVIEW"

    }
    return JSON.stringify(request)
}

export const updateCartViewIntent = (visitId, dispatch) => {

    let url = apiUrl().updateintentcartAcc + '/' + visitId;
    let request = getRequest();
    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true } });
    return new Promise((resolve, reject) => {
        api(url, 'POST', request).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data)) {
                // logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCouponMultiuse', "update Cart - Success"));
                //Process response and do prefetch
                dispatch({
                    type: "UPDATE_CART",
                    value: {
                        cartResponse: response.data.cartTierPricing,
                        cartHeader: getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                        cartData: getCartData(response.data.cartTierPricing.tierContent, visitId),
                        cartOrderDetail: response.data.orderDetail,
                        cartOrderProperty: response.data.orderProperty
                    }
                });
                resolve(response.data);
            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
            .catch(error => {
                reject('error-updateintent')
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                errorAction("ERROR", "error-updateintent", error.message, "applogs", visitId, dispatch, false, "");
            });
    })
}

export const validateCart = (visitId) => {
    let url = apiUrl().validateCart + '/' + visitId;
    api(url, 'GET').then(response => {
        return response;
    })
}
export const updateFlowType = (flowType, dispatch, visitId) => {
    if (flowType && InHomeUtils.isNotEmpty(flowType)) {
        const updateFlowTypeUrl = apiUrl().updateFlowType;
        let request = JSON.stringify({ flowType });
        let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
        api(updateFlowTypeUrl, 'POST', request).then(response => {
            if ((InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) &&
                (response.meta.code === 200 || response.meta.code === 200.01))) {
                dispatch({ type: "UPDATE_FLOWTYPE", value: { flowType: flowType } });
                logKafka("ERROR", "LoopQual", "CheckFlowTypeChanges" + "_" + flowType, getErrorLogUrl, "applogs", visitId, "try");
            }
            else if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) &&
                response.meta.code === 500.01) {
                loaderActive({ isLoaderActive: false }, dispatch)
            }
            else {                 
                logKafka("ERROR", "LoopQual", "SystemError" + response + "_" + flowType, getErrorLogUrl, "applogs", visitId);
                loaderActive({ isLoaderActive: false }, dispatch)
            }
            
        })
            .catch(error => {                    
                logKafka("ERROR", "LoopQual", error.message, getErrorLogUrl, "applogs", visitId);
                loaderActive({ isLoaderActive: false }, dispatch)
            });
    }
}
export const getMoveLandingExperience = (dispatch, visitId, checkCond = false, lqState = null, reAttemptCount = 0) => {
    let queryString = "?skipCart=n", goToBuildProduct = false, goToLanding = false, timeout = 3000;
    //checkCond conditions for fcp if it is true
    if (lqState && checkCond) {
        const toAddrId = lqState && lqState.selectedAdr && lqState.selectedAdr.addressID;
        const fromAddrId = lqState && lqState.custFromAddrId;
        if (toAddrId === fromAddrId) {
            //errorAction("LBO", "CheckLQ", "SameAddressMove", "applogs", "", dispatch, true, "SameAddressMove");
            window.location.href = "https://www.verizon.com/consumer/myverizon/router";
            return;
        }
    }

    return new Promise((resolve, reject) => {
        let url = apiUrl().MoveLandingExperience + queryString;
        loaderActive({ isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now.", isLoaderImg: "loader" }, dispatch);
        setTimeout(() => {
            api(url, 'GET', '').then(response => {
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    dispatch({ type: 'MOVE_LANDING', value: response.data });

                    //Friends & Family change
                    if (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.ffpromoExists) && response.data.ffpromoExists) {
                        let ffValidationInfo = {
                            ffCoupon: 'moveProfileFFPromo',
                            leadListID: 'moveProfileFFPromo',
                            ffCouponError: false,
                            ffValidationSucess: true,
                            ffValidationFailure: false,
                            ffValidationErrorType: '',
                            isFFCheckoutValidation: false,
                            profileDataSpeed: ''
                        }
                        dispatch({ type: 'FFCOUPONVALIDATIONSUCCESS', value: ffValidationInfo });
                    }

                    //Visible & prePaid change
                    if (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.visPrepromoExists) && response.data.visPrepromoExists) {
                        let visPreCouponInfo = {
                            visPreCoupon: 'moveProfileVisPrePromo',
                            leadListID: 'moveProfileVisPrePromo',
                            visPreCouponError: false,
                            visPreValidationSucess: true,
                            visPreValidationFailure: false,
                            visPreValidationErrorType: '',
                            isVisPreCheckoutValidation: false,
                            isDiscountEligible: true,
                            isDiscountApplied: true
                        }
                        dispatch({ type: 'VISPRECOUPONVALIDATIONSTATUS', value: visPreCouponInfo });
                    }

                    //checkFcp conditions && FCP flow
                    // if(lqState && lqState.isFCPflow){
                    if (response.data.fcpflow || lqState?.isFcpInProfile) {
                        if (response.data.movesEligibility === 'SEAMLESS') {
                            dispatch({ type: 'MOVE_ELIGIBILITY', value: response.data.movesEligibility });
                            redirectTo(Pages.moveLanding, dispatch)
                            resolve(response.data);
                            return
                        } else {
                            //getCompareCart(dispatch, visitId);
                            let validatePromise = clearCart(visitId, dispatch);
                            dispatch({ type: 'EMPTYBUILDFIOSSTATE', value: "" });
                            Promise.all([validatePromise])
                                .then(response => {
                                    if(response?.[0])
                                    {
                                    dispatch({
                                        type: "UPDATE_CART",
                                        value: {
                                            cartResponse: InHomeUtils.isNull(response[0].data.cartTierPricing) ? null : response[0].data.cartTierPricing,
                                            cartHeader: InHomeUtils.isNull(response[0].data.cartTierPricing) ? null : getCartHeader(response[0].data.cartTierPricing.tierContent, visitId),
                                            cartData: InHomeUtils.isNull(response[0].data.cartTierPricing) ? null : getCartData(response[0].data.cartTierPricing.tierContent, visitId),
                                            cartOrderDetail: InHomeUtils.isNull(response[0].data.cartTierPricing) ? null : response[0].data.orderDetail
                                        }
                                    });
                                    }else{
                                        dispatch({
                                            type: "UPDATE_CART",
                                            value: {
                                                cartResponse: null,
                                                cartHeader: null,
                                                cartData: null,
                                                cartOrderDetail: null
                                            }
                                        });
                                    }
                                    redirectTo(Pages.BuildProduct, dispatch);
                                })
                            return
                        }
                    }
                    else {
                        //Non FCP flow
                        //check if it is partial move (NONSEAMLESS with recommendation as null)
                        if (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.movesEligibility) &&
                            ((response.data.movesEligibility === "NONSEAMLESS" && response.data.recommendations === null))) {
                            getCompareCart(dispatch, visitId);
                            redirectTo(Pages.BuildProduct, dispatch)
                        }
                        else {
                            redirectTo(Pages.moveLanding, dispatch)
                            resolve(response.data);
                        }
                    }

                }
                else if (reAttemptCount < 3){
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    getMoveLandingExperience(dispatch, visitId, checkCond, lqState, reAttemptCount + 1)
                } 
                else {
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    reject('error-getMoveLandingExperience  , response: ' + response);
                    if (response.data != null) {
                        errorAction("LBO", "CheckLQ", "", "applogs", visitId, dispatch, true, response.data.movesEligibility);
                    } else {
                        errorAction("LBO", "CheckLQ", "", "applogs", visitId, dispatch, true, "movesDataNull");
                    }
                }
            })
                .catch(error => {
                    reject('error-getMoveLandingExperience');
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    errorAction("ERROR", "moveLanindg", error.message, "applogs", visitId, dispatch, false, "");
                });
        }, timeout);
    })
}

export const getMoveLandingExperienceFromJSON = (dispatch, visitId) => {
    let response = movesExpJson;
    dispatch({ type: 'MOVE_LANDINGFROMJSON', value: response.data });
    return response;
}

export const getViewdetailsExperienceFromJSON = (dispatch, id) => {
    let cartJson = sampleCartJson;
    //if (id === "SM_EXISTINGCART") {
    dispatch({
        type: "UPDATE_CART",
        value: {
            cartResponse: cartJson.data.tierPricing,
            cartHeader: getCartHeader(cartJson.data.cartTierPricing.tierContent),
            cartData: getCartData(cartJson.data.cartTierPricing.tierContent),
            cartOrderDetail: cartJson.data.orderDetail,
            cartOrderProperty: cartJson.data.orderProperty
        }
    });
}

export const getFaqMoveLanding = (dispatch, visitId, pageName) => {
    try {
        logOtherInfo(detailsInfo('MoveLanding', visitId, 'getFaqMoveLanding', "Inside getFaqMoveLanding"));
        let url = apiUrl().getFaq + '/' + pageName;

        api(url, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response))
                dispatch({ type: 'FAQ_MOVELANDING_CONTENT', value: response });
        })
            .catch(error => {
                let errorMsg = `MethodName:getFaqMoveLanding,errorMessage:${error.message}`;
                logKafka("ERROR", "MoveLanding", errorMsg, getErrorLogUrl, "applogs", visitId);
                errorAction("ERROR", "MoveLanding", error.message, "applogs", visitId, dispatch, false, "");
            });
    }
    catch (ex) {
        catchJSException('MoveLanding', visitId, 'getFaqMoveLanding', ex);
    }
}

export const getViewdetailsExperience = (dispatch, visitId, fromRec) => {
    // if (id === "SM_EXISTINGCART") {
    let url = apiUrl().getCartAcc + '/' + visitId;

    if (InHomeUtils.isNotNull(fromRec) && fromRec == "Y") {
        url = apiUrl().getCartAcc + '/' + visitId + '?viewonly=true';
    }
    api(url, 'GET', '').then(response => {
        if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
            dispatch({
                type: "UPDATE_CART",
                value: {
                    cartResponse: response.data.cartTierPricing,
                    cartHeader: getCartHeader(response.data.cartTierPricing.tierContent),
                    cartData: getCartData(response.data.cartTierPricing.tierContent),
                    cartOrderDetail: response.data.orderDetail,
                    cartOrderProperty: response.data.orderProperty
                }
            });
        }
    })
        .catch(error => {
            errorAction("ERROR", "moveLanindg", error.message, "applogs", visitId, dispatch, false, "");
        });

}

export const getComparePriceFromJSON = (dispatch, visitId) => {
    let cartJson = sampleComparePrice;

    // if (id === "SM_EXISTINGCART") {
    dispatch({
        type: "UPDATE_CART",
        value: {
            cartResponse: cartJson.data.newCartInfo.result.cartTierPricing,
            cartHeader: getCartHeader(cartJson.data.newCartInfo.result.cartTierPricing.tierContent),
            cartData: getCartData(cartJson.data.newCartInfo.result.cartTierPricing.tierContent),
            cartOrderDetail: cartJson.data.newCartInfo.result.orderDetail,
            cartOrderProperty: cartJson.data.newCartInfo.result.orderProperty
        }
    });

    dispatch({
        type: "PROFILE_CART",
        value: {
            cartResponse: cartJson.data.profileCartInfo.result.tierPricing,
            cartHeader: getCartHeader(cartJson.data.profileCartInfo.result.tierPricing.tierContent),
            cartData: getCartData(cartJson.data.profileCartInfo.result.tierPricing.tierContent),
            cartOrderDetail: cartJson.data.profileCartInfo.result.orderDetail
        }
    });
    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    // }
}

export const getCompareCart = (dispatch, visitId) => {
    let url = apiUrl().compareCart + '/' + visitId;
    api(url, 'GET', '').then(response => {
        if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
           if(response?.data?.profileCartInfo?.tierPricing?.tierContent)
           {
            dispatch({
                type: "PROFILE_CART",
                value: {
                    cartResponse: response.data.profileCartInfo.tierPricing,
                    cartHeader: getCartHeader(response.data.profileCartInfo.tierPricing.tierContent),
                    cartData: getCartData(response.data.profileCartInfo.tierPricing.tierContent),
                    cartOrderDetail: response.data.profileCartInfo.orderDetail
                }
            });
            dispatch({ type: "ISMNHVALUECUSTOMER", value: response?.data?.isMNHValueCustomer === "Y" });
           }
            dispatch({
                type: "UPDATE_CART",
                value: {
                    cartResponse: response.data.newCartInfo.cartTierPricing,
                    cartHeader: getCartHeader(response.data.newCartInfo.cartTierPricing.tierContent),
                    cartData: getCartData(response.data.newCartInfo.cartTierPricing.tierContent),
                    cartOrderDetail: response.data.newCartInfo.orderDetail,
                    cartOrderProperty: response.data.orderProperty
                }
            });

            // dispatch({
            //     type: "PROFILE_CART",
            //     value: {
            //         cartResponse: response.data.profileCartInfo.tierPricing,
            //         cartHeader: getCartHeader(response.data.profileCartInfo.tierPricing.tierContent),
            //         cartData: getCartData(response.data.profileCartInfo.tierPricing.tierContent),
            //         cartOrderDetail: response.data.profileCartInfo.orderDetail
            //     }
            // });
        }
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    })
        .catch(error => {
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            errorAction("ERROR", "getComparePriceFromJSON", error.message, "applogs", visitId, dispatch, false, "");
        });
}

export const updatecartFlowStatus = (dispatch, value) => {
    dispatch({
        type: "UPDATE_CART_FLOW",
        value: value
    })
}

export const updateTNStatus = (dispatch, value) => {
    dispatch({
        type: "TN_OPT",
        value: value
    })
}

const getMovesRequest = (moveseligible) => {
    let movesRequest = {
        key: moveseligible,
        value: "YES",
        action: "ADD"

    }
    return JSON.stringify(movesRequest)
}

export const updateCartViewIntentForMoves = (moveseligible, visitId, dispatch) => {

    let url = apiUrl().updateintentcartAcc + '/' + visitId;
    let movesRequest = getMovesRequest(moveseligible);
    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true } });
    return new Promise((resolve, reject) => {
        api(url, 'POST', movesRequest).then(response => {
            // 
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data)) {
                // logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCouponMultiuse', "update Cart - Success"));
                //Process response and do prefetch
                dispatch({
                    type: "UPDATE_CART",
                    value: {
                        cartResponse: response.data.cartTierPricing,
                        cartHeader: InHomeUtils.isNull(response.data.cartTierPricing) ? null : getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                        cartData: InHomeUtils.isNull(response.data.cartTierPricing) ? null : getCartData(response.data.cartTierPricing.tierContent, visitId),
                        cartOrderDetail: response.data.orderDetail,
                        cartOrderProperty: response.data.orderProperty
                    }
                });
                resolve(response.data);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
            else { //error while updating cart
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
        })
    })
}

export const clearCart = (visitId, dispatch) => {
    try {
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true } });
        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'clearCart', "Inside clearCart", PAGEACTIVITY.UA));
        let url = apiUrl().clearCart + '/' + visitId;
        let request = getClearCartRequest();
        return new Promise((resolve, reject) => {
            api(url, 'POST', request).then(response => {
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data)) {
                    // dispatch ({ type: BuildProduct.clearBuildProductState, value: "" });
                    // dispatch({
                    //     type: "UPDATE_CART",
                    //     value: {
                    //         cartResponse: InHomeUtils.isNull(response.data.cartTierPricing) ? null : response.data.cartTierPricing,
                    //         cartHeader: InHomeUtils.isNull(response.data.cartTierPricing) ? null : getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                    //         cartData: InHomeUtils.isNull(response.data.cartTierPricing) ? null : getCartData(response.data.cartTierPricing.tierContent, visitId),
                    //         cartOrderDetail: InHomeUtils.isNull(response.data.cartTierPricing) ? null : response.data.orderDetail
                    //     }
                    // });
                    resolve(response)
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'clearCart', "clearCart Success", PAGEACTIVITY.UA));
                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'clearCart', "clearCart Failed", PAGEACTIVITY.UA));
                }
                const perkRes = response?.data?.cartTierPricing?.tierContent?.[0]?.sections?.section?.find(sec => sec?.sectionName?.toLowerCase() === 'perks');
                    if(perkRes && InHomeUtils?.isNotNull(perkRes?.subSections) && InHomeUtils?.isNotNull(perkRes?.subSections?.subSection) && InHomeUtils.isNotNull(perkRes?.subSections?.subSection?.length > 0)) {
                        const perkProds = perkRes?.subSections?.subSection?.find(sub => sub?.sectionType?.toLowerCase() === 'perks');
                        const prods = perkProds?.products;
                        dispatch({ type: 'PERKS_SELECTEDPROD', value: prods});
                    } else {
                        dispatch({ type: 'PERKS_SELECTEDPROD', value: []});
                    }
            })
                .catch(error => {
                    reject(error)
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    let errorMsg = `MethodName:clearCart,errorMessage:${error.message}`;
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.RC, visitId, 'clearCart', errorMsg, PAGEACTIVITY.UA));

                });
        })
    }
    catch (ex) {
        catchJSException('moveExp', visitId, 'clearCart', ex);
    }
};

const getClearCartRequest = () => {
    let request = { serviceType: 'ALL', productType: 'All' }
    return JSON.stringify(request)
};

export const updateCustomerOption = (dispatch, value) => {
    dispatch({
        type: Moves.UPDATE_CUST_OPT,
        value: value
    })
}

export const updateCustomermakeChanges = (dispatch, value) => {
    dispatch({
        type: 'MOVE_CUST_OPT_MAKECHANGES',
        value: value
    })
}